import _ from 'lodash'
import { call, put, select, takeLatest, race, take } from 'redux-saga/effects'

import VALUES from 'core/data-model/constants/values'
import { isValidAge } from 'core/service/insured/birthdate'
import { UPDATE_BIRTHDATE } from 'quick-quote/insured-information/actions'
import { getAge } from 'quick-quote/insured-information/selectors'
import { editSumAssured, editRiderSumAssured } from 'quick-quote/product-common/coverage-plan/actions'
import { editPerfectLifePlan } from 'quick-quote/product-perfect-life/coverage-plan/actions'
import { SELECTED_PRODUCT } from 'quick-quote/product-selection/actions'
import { getDisplayProducts, getSelectedDisplayProductCode } from 'quick-quote/product-selection/selectors'

import { selectBasicPlan, SELECT_PERFECT_LIFE_PLAN } from './actions'

/**
 * createProductPerfectLifeFunc
 * @param productCommonCoverageFunc {ReturnType<import('quick-quote/product-common/coverage-plan/sagas').createProductCommonCoverageFunc>}
 */
export function createProductPerfectLifeFunc(productCommonCoverageFunc) {
  const _switchPerfectLifeProductByAge = (products, age) => {
    const { value, unit } = age
    return _.find(products, (product) => isValidAge(value, unit, _.get(product, 'entryAge')))
  }

  const _isPerfectLifeGroup = (productCode) => _.includes(VALUES.PERFECT_LIFE, productCode)

  const _getProductGroupCode = (productCode) => {
    if (_isPerfectLifeGroup(productCode)) {
      return VALUES.PERFECT_LIFE
    }
  }

  const switchProductByBirthDate = function*() {
    const productCode = yield select(getSelectedDisplayProductCode)
    if (!_isPerfectLifeGroup(productCode)) return

    const age = yield select(getAge)
    const products = yield select(getDisplayProducts)
    const productGroupCodes = _getProductGroupCode(productCode)

    const productGroup = _.filter(products, (product) => _.includes(productGroupCodes, _.get(product, 'code')))
    const product = _switchPerfectLifeProductByAge(productGroup, age)
    if (product !== undefined && productCode !== _.get(product, 'code')) {
      yield put(selectBasicPlan(product))
      yield call(productCommonCoverageFunc.populateAvailableRiders)
    }
  }

  const selectPerfectLifePlan = function*(action) {
    const planCode = action.payload
    const displayProducts = yield select(getDisplayProducts)
    const productCode = yield select(getSelectedDisplayProductCode)
    const product = _.find(displayProducts, { code: productCode })
    product.selectedCampaignPlan = planCode
    yield put(editPerfectLifePlan(product))

    const perfectLifePlans = product.plans
    const selectedPerfectLifePlans = perfectLifePlans.filter((v) => v.planCode === planCode)
    const selectedPerfectLifePlan = _.get(selectedPerfectLifePlans, '0')
    yield put(editSumAssured(_.get(selectedPerfectLifePlan, 'sumAssured')))

    const { success } = yield race({
      success: take('UPDATE_RIDERS_BENEFITS'),
    })

    if (success) {
      for (let rider of _.get(selectedPerfectLifePlan, 'riders', [])) {
        yield put(editRiderSumAssured(rider.code, rider.sumAssured))
      }
    }
  }

  return {
    _switchPerfectLifeProductByAge,
    switchProductByBirthDate,
    selectPerfectLifePlan,
  }
}

/**
 * @param serviceWrapper {Awaited<ReturnType<import('core/service-wrapper/wrapper').buildServiceWrapper>>}
 */
export function* watchers(serviceWrapper) {
  const { PERFECT_LIFE } = serviceWrapper.products
  yield [
    takeLatest([UPDATE_BIRTHDATE, SELECTED_PRODUCT], PERFECT_LIFE.switchProductByBirthDate),
    takeLatest([SELECT_PERFECT_LIFE_PLAN], PERFECT_LIFE.onUpdateSelectedBasicPlan),
  ]
}

export const sagas = watchers
